import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BulkUploadListFilters from '../components/BulkUploadListFilters';
import TopBar from '../../../components/TopBar';
import BulkUploadListPageActions from '../components/BulkUploadListPageActions';
import BulkUploadTable from '../components/BulkUploadTable';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { fetchBulkUploadRequest, markBulkUploadProceeded } from '../../../api/bulkUpload/bulkUploadSlice';
import { Stack } from '@mui/material';
import FeatureNotSupportedDialog from '../../common/FeatureNotSupportedDialog';
import useBulkUploadFilters from '../../../components/filters/BulkUploadFilterHelper';

const filters = [
  {
    type: 'search',
    options: [
      {
        key: 'filename',
        placeholder: 'File Name',
      },
      {
        key: 'status',
        placeholder: 'Status',
      },
    ],
  },
];

function BulkUploadListPage() {
  useDocumentTitle('Bulk Upload List');
  const user = useSelector((state) => state.org.org.user);
  const dispatch = useDispatch();
  const subscription = useSelector((state) => state.org.org.subscription);
  const isBulkUploadFeatureEnabled = subscription?.features?.enable_bulk_upload;
  const isSftpFeatureEnabled = subscription?.features?.enable_sftp;

  const {
    searchTerm,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleDateRangeChange,
    handlePaginationChange,
  } = useBulkUploadFilters({
    defaultQuery: {},
    dispatch,
    fetchAction: fetchBulkUploadRequest,
    markCreatedAction: markBulkUploadProceeded,
  });

  return isBulkUploadFeatureEnabled || isSftpFeatureEnabled ? (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title="Bulk Upload">{user?.permissions?.documents === 2 && <BulkUploadListPageActions />}</TopBar>
      <BulkUploadListFilters
        filters={filters}
        selectedFilter={currentQuery.selectedFilter}
        onFilterChange={handleFilterChange}
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
        onSearchKeyPress={handleSearchKeyPress}
        onDateRangeChange={handleDateRangeChange}
      />
      <BulkUploadTable handlePaginationChange={handlePaginationChange} />
    </Stack>
  ) : (
    !isBulkUploadFeatureEnabled && !isSftpFeatureEnabled && (
      <FeatureNotSupportedDialog
        title={'Bulk Upload'}
        description={
          'Upload and process multiple documents simultaneously, saving time and streamlining your workflow.'
        }
      />
    )
  );
}

export default BulkUploadListPage;
